import { NonIdealState, NonIdealStateIconSize } from "@blueprintjs/core";
import React from "react";
import { useNavigate } from "react-router-dom";

import { useDefaultPlayData } from "../../../hooks";
import { useCreatePlayMutation } from "../../../redux/slices";
import { Button } from "../../Button/button";

export interface NoPlaysPromptProps {
  setActivePlayId: (id: string) => void;
}

export const NoPlaysPrompt = ({ setActivePlayId }: NoPlaysPromptProps) => {
  const navigate = useNavigate();
  const { getDefaultPlayData } = useDefaultPlayData();

  const [createPlay] = useCreatePlayMutation();

  const handleClickCreatePlay = async () => {
    const playData = getDefaultPlayData();
    try {
      const newPlayResponse = await createPlay({ play: playData }).unwrap();
      const newId = newPlayResponse.id || "";
      setActivePlayId(newId);
      navigate(`/plays/${newId}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <NonIdealState
      title="No Plays"
      description="Your search returned no plays. Try adjusting your search criteria or creating a new play."
      layout={"vertical"}
      icon="search"
      iconSize={NonIdealStateIconSize.STANDARD}
      action={
        <Button icon="plus" intent="primary" onClick={handleClickCreatePlay}>
          Create Play
        </Button>
      }
    />
  );
};
